import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ccc_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SERVING_ROLES = [
  "Musicians",
  "Praise & Worship / Choir",
  "Ministers",
  "Elders",
  "Deacons",
  "Armor Bearers",
  "Executive Assistant",
  "Ushers",
  "Greeters",
  "Hospitality",
  "Social Media",
  "Media & Production (Audio/Visual)",
  "Children's Ministry",
  "Youth Ministry",
  "Prayer Team",
  "Outreach & Evangelism",
  "Security",
  "Administration",
  "Finance / Stewardship",
  "Transportation",
];

export const CONTACT = {
  email: "thechangecenteratlanta@gmail.com",
  facebook: "changechurchatlanta",
  facebookUrl: "https://facebook.com/changechurchatlanta",
  instagram: "changechurchatlanta",
  instagramUrl: "https://instagram.com/changechurchatlanta",
  website: "thechangecenterchurch.org",
  websiteUrl: "https://thechangecenterchurch.org",
  pastor: "Pastor Duane Thomas, Jr.",
  cashApp: "$kaffeine88",
  cashAppUrl: "https://cash.app/$kaffeine88",
  zelle: "404-326-0944",
  location: "Clayton County, Georgia",
  launchWindow: "September – November 2026",
};
